import TextMessage from './TextMessage';

export function ImageMessage({ message }) {
  const mediaUrl = message.media_url;
  return (
    <>
      <div className="mb-2">
        <img
          src={mediaUrl}
          alt="Media attachment"
          className="rounded h-[200px] w-[200px] cursor-pointer"
          onClick={() => window.open(mediaUrl, '_blank')}
          onError={(e) => {
            // If image fails to load, replace with download link
            e.target.style.display = 'none';
            e.target.parentNode.innerHTML = `
        <a href="${mediaUrl}" target="_blank" rel="noopener noreferrer" class="flex items-center text-blue-600 hover:underline">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
          Download attachment
        </a>
      `;
          }}
        />
      </div>
      <p className="text-sm">
        <TextMessage message={message} />
      </p>
    </>
  );
}

export function AudioMessage({ message }) {
  const mediaUrl = message.media_url;
  const mediaType = message.message_type || '';
  return (
    <>
      <div className="mb-2">
        <audio controls className="w-full">
          <source src={mediaUrl} type={mediaType} />
          Your browser does not support the audio element.
        </audio>
      </div>
      <p className="text-sm">
        <TextMessage message={message} />
      </p>
    </>
  );
}

export function VideoMessage({ message }) {
  const mediaUrl = message.media_url;
  const mediaType = message.message_type || '';
  return (
    <>
      <div className="mb-2">
        <video controls className="w-full max-h-60 rounded">
          <source src={mediaUrl} type={mediaType} />
          Your browser does not support the video element.
        </video>
      </div>
      <p className="text-sm">
        <TextMessage message={message} />
      </p>
    </>
  );
}

export function DownloadMessage({ message }) {
  const mediaUrl = message.media_url;
  return (
    <>
      <div className="mb-2">
        <a href={mediaUrl} target="_blank" rel="noopener noreferrer" className="flex items-center text-blue-600 hover:underline">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
          Download attachment
        </a>
      </div>
      <p className="text-sm">
        <TextMessage message={message} />
      </p>
    </>
  );
}
